import { red } from '@material-ui/core/colors';
import React from 'react';
/*
* ---------------------------------------------------------------
*  NewsToggle（単体のアコーディオン付きニュース）
* ----------------------------------------------------------------
*/
class NewsToggle extends React.Component {

    constructor(props) {
        super(...arguments);
        this.state = {
            id: props.data.id,
            title: props.data.title,
            date: props.data.date,
            details: props.data.details,
            haveDetails: props.data.haveDetails,
            link: props.data.link,
            haveLink: props.data.haveLink,
            linkName: props.data.linkName,
            links: props.data.links,
            isNew: props.data.isNew,
            isOpen: false
        }
    }


    /*
    * ---------------------------------------------------------------
    *  slideToggle（要素をスライドで表示・非表示を切り替える関数）
    * ----------------------------------------------------------------
    */
    testToggle(e) {
        let parent = e.currentTarget.parentNode;
        // 詳細文が無く、リンクが１つだけあればそこに飛ばす
        if(!parent.classList.contains('have-details')){
            if(!parent.classList.contains('have-link')){
                return;
            }else if(this.state.links.length === 1){
                window.location.href = this.state.links[0].url;
                return;
            }
        }
        // 選択中の要素と同じ階層にある詳細文をスライドする
        this.setState(state => ({
            isOpen: !state.isOpen
        }));
    }


    render() {        
        return (
            <div key={ this.state.id } className={'top-news__item ' + (this.state.haveDetails ? 'have-details ' : 'no-details ') + (this.state.haveLink ? 'have-link' : 'no-link')}>
                <div className="top-news__item-top" onClick={this.testToggle.bind(this)}>
                    <div className="top-news__item-heading">
                        <div className="top-news__item-date">{this.state.date}　</div>
                        <div className="top-news__item-heading-text">
                            { this.state.title }{this.state.isNew ? <span className='top-news__tag'>New</span> : ''}
                        </div>
                    </div>
                    <div className="top-news__slide-icon">
                        <i className={'fas fa-angle-right ' + (this.state.isOpen ? 'accordion-isOpen' : '')}></i>
                    </div>
                </div>
                <div className={'top-news__item-accordion ' + (this.state.isOpen ? 'accordion-isOpen' : '')}>
                    <div className='top-news__item-content'>
                        <div className='top-news__item-text'>{this.state.details}</div>
                        <div className='top-news__item-link'>
                            {this.state.links.map((item, index) => {
                                return (
                                    <a href={item.url}>{item.name}</a>
                                )
                            })}
                            {/* <a href={this.state.link}>{this.state.linkName}</a> */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

/*
* ---------------------------------------------------------------
*  NewsList（新着情報を引っ張ってNewsToggleに渡すコンポーネント）
* ----------------------------------------------------------------
*/
class NewsList extends React.Component {

    constructor(props) {
        super(...arguments);
        this.state = {
            infos : [],
            accordionStyles : []
        }
        // お知らせテスト
        // ロード時にSSSAPIを呼び出す
        const API_URL = "https://api.sssapi.app/Ib5jWlkbmQAxHYa2U72lH";
        fetch(API_URL).then((response) => {
            if (response.status != 200) {
                // APIの呼び出しが失敗した場合
                console.log(response.status);
                return response
                .json()
                .then((error) => alert(JSON.stringify(error, null, 2)));
            }

            // APIの呼び出しが成功した場合
            return response
                .json() // JSONデータを取得
                .then((data) => {
                    data.reverse();
                    let news = [];
                    let styles = [];
                    // 取得したデータを挿入
                    data.forEach((v) => {
                        console.log(v);
                        // 日付から新しいか判別
                        let data = this.judgeIsNew(v['日付']);
                        // 詳細文の有無を判別
                        let shousai = v['詳細'];
                        let haveDetails = false;
                        if(shousai != null){
                            haveDetails = true;
                        } else {
                            shousai = '';
                        }
                        // リンクの有無を判別
                        let link = v['リンク'];
                        let haveLink = false;
                        let linkName = '';
                        let links = [];
                        if(link != null){
                            haveLink = true;
                            // リンクの数（行数）だけタグを作る
                            let tmpLinks = link.split(/\r\n|\n/);
                            linkName = v['リンク名'] != null ? v['リンク名'] : '詳細はこちら';
                            let tmpLinkNames = linkName.split(/\r\n|\n/);
                            for(let i = 0; i < tmpLinks.length; i++){
                                // リンク名があればそれを、無ければデフォルト文をラベルとする
                                let lName = '詳細はこちら';
                                if(typeof tmpLinkNames[i] !== 'undefined'){
                                    if(tmpLinkNames[i] !== null){
                                        lName = tmpLinkNames[i];
                                    }
                                }
                                // リンクをオブジェクトとして配列に追加する
                                links.push({url: tmpLinks[i], name: lName});
                            }
                        } else {
                            link = '#';
                        }
                        let info = {
                            id: v['id'],
                            title: v['タイトル'],
                            date: data.date,
                            details: shousai,
                            haveDetails: haveDetails,
                            link: link,
                            linkName: linkName,
                            links: links,
                            haveLink: haveLink,
                            isNew: data.isNew
                        };
                        news.push(info);
                        let accordStyle = {
                            background: "#f2f2f3"
                        }
                        styles.push(accordStyle);
                        // this.state.infos.push(info);
                    });
                    this.setState({infos: news, accordionStyles: styles});
                    console.log("this.state", this.state);
                });
        });
    }

    /*
    * ---------------------------------------------------------------
    *  judgeIsNew（日付から新しいかどうか判別する関数）
    * ----------------------------------------------------------------
    */
    judgeIsNew(orgDate, interval = 14) {
        let date = orgDate;
        // 日付を整形
        date = date.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
        date = date.replace(/年|月/g, '/');
        date = date.replace(/日/g, '');
        // Date型に変換
        date = new Date(date);
        const isHen = Number.isNaN(date.getDate());
        let data;
        // Date型にできない場合は新しくないと判断し、元の日付を返す
        if(isHen){
            data = {
                date: orgDate,
                isNew: false
            }
        } else {
            // (interval)日後の日付と今日の日付を比較し、新しいかどうか判断する
            let dateStr = date.getFullYear()
                + '/' + ('0' + (date.getMonth() + 1)).slice(-2)
                + '/' + ('0' + date.getDate()).slice(-2);
            date.setDate(date.getDate() + interval + 1);
            let nowDate = new Date();
            data = {
                date: dateStr,
                isNew: date > nowDate
            }
        }
        return data;
    }


    render() {        
        return (
            <div className="top-news">
                { this.state.infos.map((info, index) => {
                    return (
                        <NewsToggle data={info}/>
                    )
                }) }
            </div>
        )
    }
}
export default NewsList;